import Vue from 'vue'
import Router from 'vue-router'

import Protocol from './views/Protocol'
import Gulou from './views/gulou'
import Unicorn from './views/unicorn'
import Ai from './views/ai'
import Talent from "./views/talent"
Vue.use(Router)

export default new Router({

  routes: [
    {
      path:'/',
      name:'protocol',
      component:Protocol
    },
    {
      path:'/gulou',
      name:'gulou',
      component:Gulou
    },{
      path:'/unicorn',
      name:'unicorn',
      component:Unicorn
    },{
      path:'/ai',
      name:'ai',
      component:Ai
    },{
      path:'/talent',
      name:'talent',
      component:Talent
    }
  ],
   scrollBehavior(to,from,savedPosition){
      if(savedPosition){
        return savedPosition;
      }else{
        return {x:0,y:0}
      }
    }
})
